import { text } from "@fortawesome/fontawesome-svg-core";
import { Link } from "react-router-dom";
import { useState } from "react";
import Marquee from "react-fast-marquee";

const marqueeData = [


    {
        text: "Applications invited under EngSUI scheme ",
        link: '/contact-us',
    },
    {
        text: "Applications invited from SC, ST and OBC entrepreneurs under VCF-SC, VCF- ST & BC",
        link: '/contact-us',
    },
    {
        text: "Applications invited from MSMEs under MSME Innovative Design Component",
        link: '/contact-us',
    },
    {
        text: "Applications invited for the MSME Innovative Scheme (Incubation Component) under MSME Idea Hackathon 4.0!",
        link: 'https://www.linkedin.com/posts/iit-ropar-technology-business-incubator-foundation_msmeideahackathon4instructions-forparticipation-activity-7242111446526877696-Vguh?utm_source=share&utm_medium=member_android',
    },

]
const Updates = () => {
    const [Speed, setSpeed] = useState(70);
    return (
        <>
            <div className="w-full flex justify-center items-center grid grid-col-1 bg-blue-500" id="update bar" >
                <Marquee speed={Speed} className="w-full overflow-y-hidden">
                    {marqueeData.map((data, i) => (
                        <div className=" w-full flex flex-col  items-center justify-center p-2 px-24">
                            <Link
                                to={data.link}
                                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                                <span className="text-white font-bold font-roboto text-lg">{data.text}</span>
                            </Link>
                            {/* <span className="text-black">{data.name}</span> */}
                        </div>
                    ))}
                </Marquee>
            </div>
        </>
    );
};

export default Updates;
